var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreAvailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 450,
    viewBox: "0 0 450 450",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a2YQ2lPYez",
    d: "m776.76,310.84c0,82.79 -67.21,150 -150,150c-82.78,0 -150,-67.21 -150,-150c0,-82.79 67.22,-150 150,-150c82.79,0 150,67.21 150,150z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 412,
    width: 412,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("filter", {
    transform: "translate(-2,-3) translate(3,5) translate(23,19) translate(0,3) translate(0,-111) translate(0,0.160003662109375) translate(-427,0) translate(0.239990234375,0) ",
    primitiveUnits: "userSpaceOnUse",
    filterUnits: "userSpaceOnUse",
    height: 523,
    width: 523,
    y: 49.84,
    x: 365.76,
    id: "shadow13372329"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.07
  })), /*#__PURE__*/React.createElement("path", {
    filter: "url(#shadow13372329)",
    fill: "white",
    id: "l9NGZakuh",
    d: "m373.99999,224.000004c0,82.79 -67.21,150 -150,150c-82.78,0 -150,-67.21 -150,-150c0,-82.79 67.22,-150 150,-150c82.79,0 150,67.21 150,150z"
  })), /*#__PURE__*/React.createElement("use", {
    x: -402.76001,
    y: -86.839996,
    id: "svg_4",
    fill: "#dd9d00",
    xlinkHref: "#a2YQ2lPYez"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("use", {
    x: -402.76001,
    y: -86.839996,
    id: "svg_6",
    strokeOpacity: 0.67,
    strokeWidth: 150,
    stroke: "#dd9d00",
    fillOpacity: 0,
    xlinkHref: "#a2YQ2lPYez"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreAvailable);
export default __webpack_public_path__ + "static/media/MoreAvailable.112a4adc355021c0f17bd0c14f732be8.svg";
export { ForwardRef as ReactComponent };